module.exports = __webpack_public_path__ + "static/media/34DSS11.6f2fc965.jpg";